export default __webpack_public_path__ + "static/media/grit-logo.69dd1cea.svg";